var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 76.99 77.08",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#ffe234;}.cls-2{fill:#ff5a72;}.cls-3{fill:#6031e6;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M18.62,22.68a4.08,4.08,0,0,1,4.06-4.06H55L66.38,7.26A4.24,4.24,0,0,0,64,0a4.58,4.58,0,0,0-.53,0H5.4A5.42,5.42,0,0,0,0,5.4V63.48A4.58,4.58,0,0,0,0,64a4.24,4.24,0,0,0,7.23,2.37L18.62,55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M59.31,14.57H19.57a5,5,0,0,0-5,5V59.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M73.72,14.6a5.25,5.25,0,0,0-.56,0H59.31L14.57,59.31V73.24a3.86,3.86,0,0,0,6.59,2.7L75.82,21.28C78.08,19,76.89,15,73.72,14.6Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon);
export default __webpack_public_path__ + "static/media/icon.111986893be0615d78cd86014d028a93.svg";
export { ForwardRef as ReactComponent };